import { TextField } from "@mui/material";
import { CommDisplayInfo } from "./ObjectPropertiesUtils";

export type CommObjectProps = {
    item: CommDisplayInfo;
};

export function CommObject({ item }: CommObjectProps) {

    function getValue(): string {
        const values = new Array<string>();
        item.name && values.push(`Name: ${item.name}`);
        item.ip && values.push(`IP: ${item.ip}`);
        item.port && values.push(`Port: ${item.port}`);
        return values.join("\n");
    }

    return (
        <TextField
            sx={{ width: 1 }}
            label="Comm Object"
            multiline={true}
            variant="filled"
            value={getValue()}
            slotProps={{
                htmlInput: {
                    readOnly: true
                }
            }}
        />
    );
}